import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Toolbar from "@material-ui/core/Toolbar";
// @material-ui/icons components
import Clear from "@material-ui/icons/Clear";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import ZoomIn from "@material-ui/icons/ZoomIn";

// core components
import AppsDropdownAlternative from "components/Dropdowns/AppsDropdownAlternative.js";
import NotificationsDropdownAlternative from "components/Dropdowns/NotificationsDropdownAlternative.js";
import UserDropdownAlternative from "components/Dropdowns/UserDropdownAlternative.js";

import boxShadows from "assets/theme/box-shadow.js";
import hexToRgb from "assets/theme/hex-to-rgb.js";

export default function AdminNavbarAlternative({ openSidebarResponsive }) {
  const theme = useTheme();
  const [showSearch, setShowSearch] = React.useState(false);
  return (
    <>
      <AppBar
        position="relative"
        elevation={0}
        color="transparent"
        sx={{
          borderBottom:
            "1px solid rgba(" + hexToRgb(theme.palette.dark.main) + ", 0.08)",
          backgroundColor: theme.palette.transparent.main,
        }}
      >
        <Toolbar disableGutters>
          <Container
            maxWidth={false}
            component={Box}
            sx={{
              [theme.breakpoints.up("md")]: {
                paddingLeft: "30px",
                paddingRight: "30px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: showSearch ? "left" : "center",
                alignItems: "center",
                width: "100%",
                marginTop: "1rem",
                marginBottom: "1rem",
                overflow: showSearch ? "hidden" : undefined,
              }}
            >
              <Box
                sx={{
                  display: showSearch ? "flex!important" : "flex",
                  alignItems: "center",
                  width: "auto",
                  marginRight: showSearch ? "0" : "1rem",
                  borderRadius: "2rem",
                  border:
                    "2px solid rgba(" +
                    hexToRgb(theme.palette.dark.main) +
                    ",0.9)",
                  backgroundColor:
                    "rgba(" + hexToRgb(theme.palette.dark.main) + ",0.9)",
                  boxShadow: boxShadows.inputBoxShadow,
                  transition: "box-shadow .15s ease",
                  color: theme.palette.gray[400],
                  [theme.breakpoints.down("sm")]: {
                    display: "none",
                    width: "100%",
                  },
                  "& div:first-of-type": {
                    flex: showSearch ? 1 : "unset",
                  },
                }}
              >
                <SearchIcon
                  sx={{
                    color: theme.palette.gray[400],
                    marginRight: "0.5rem",
                    marginLeft: "1rem",
                  }}
                />
                <InputBase
                  placeholder="Search"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: theme.palette.gray[200] + "!important",
                      width: "270px!important",
                      backgroundColor: "initial!important",
                      border: "0!important",
                      boxShadow: "none!important",
                      padding: "0!important",
                    },
                  }}
                />
                <Hidden smUp implementation="js">
                  <Clear
                    sx={{
                      color: theme.palette.gray[400],
                      marginRight: "1rem",
                      marginLeft: "-.5rem",
                      zIndex: "1",
                    }}
                    onClick={() => setShowSearch(false)}
                  />
                </Hidden>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "auto",
                  [theme.breakpoints.down("sm")]: {
                    marginLeft: "unset",
                  },
                  [theme.breakpoints.down("xs")]: {
                    display: showSearch ? "none" : "flex",
                  },
                }}
              >
                <Hidden xlUp implementation="css">
                  <IconButton onClick={openSidebarResponsive}>
                    <Box
                      component={MenuIcon}
                      sx={{
                        width: "1.5rem!important",
                        height: "1.5rem!important",
                      }}
                    />
                  </IconButton>
                </Hidden>
                <Hidden smUp implementation="css">
                  <IconButton onClick={() => setShowSearch(true)}>
                    <Box
                      component={ZoomIn}
                      sx={{
                        width: "1.5rem!important",
                        height: "1.5rem!important",
                      }}
                    />
                  </IconButton>
                </Hidden>
                <NotificationsDropdownAlternative />
                <AppsDropdownAlternative />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  [theme.breakpoints.down("sm")]: {
                    marginLeft: "auto",
                  },
                  [theme.breakpoints.down("xs")]: {
                    display: showSearch ? "none" : "flex",
                  },
                }}
              >
                <UserDropdownAlternative />
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
}
AdminNavbarAlternative.defaultProps = {
  openSidebarResponsive: () => {},
};

AdminNavbarAlternative.propTypes = {
  // use this to make the Sidebar open on responsive mode
  openSidebarResponsive: PropTypes.func.isRequired,
};
